import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';

const fancybox = {};
fancybox.fancybox = function () {
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons : [
      'zoom',
      'close'
    ],
    image : {
      preload : "auto"

    },
  });
}

fancybox.init = function() {
  this.fancybox();
}

fancybox.init();